module.exports = __webpack_public_path__ + "174ab767090fcdd52654cb39dc845fda.svg";